module.exports = __webpack_public_path__ + "img/staff-and-payroll.2a8287a7.png";